<div>{{ params.value }}</div>
